import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 10 10",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ursa-icon__InfoFilledIcon__10__ida)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M5 2.667a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25m.542 2.541a.542.542 0 0 0-1.084 0v1.875a.542.542 0 0 0 1.084 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 5a5 5 0 1 1 10 0A5 5 0 0 1 0 5m4.375-1.708a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0M5 4.667c.3 0 .542.242.542.541v1.875a.542.542 0 0 1-1.084 0V5.208c0-.299.243-.542.542-.542",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ursa-icon__InfoFilledIcon__10__ida"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10v10H0z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=InfoFilledIcon10.js.map